:host {
  display: block;
  width: 100%;
  border: solid 1px;
  border-color: $ui-purple-minus-1;
  background: $ui-purple-minus-2;
  padding: 5px 10px;
}
